import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import { allFocusAreas } from '../../data/focusIndex';
import PageHero from '../../components/PageHero/PageHero';
import Footer from '../../components/Footer/Footer';
import FocusDetail from './FocusDetail';
import './FocusAreaPage.css';

function FocusAreaPage() {
  const ref = useRevealChildren();

  return (
    <>
      <PageHero title="Focus Area" />
      <FocusNav />
      <section className="focus-page-section" ref={ref}>
        <div className="container">
          {allFocusAreas.map((area, i) => (
            <React.Fragment key={area.id}>
              <FocusDetail area={area} />
              {i < allFocusAreas.length - 1 && <hr className="focus-divider" />}
            </React.Fragment>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
}

function FocusNav() {
  return (
    <div className="focus-page-nav">
      <div className="container">
        <div className="focus-page-nav-inner">
          {allFocusAreas.map((area) => (
            <a key={area.id} href={`#${area.id}`} className="focus-page-nav-link">
              {area.title}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FocusAreaPage;
